// ~/plugins/error-handler.ts
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:error', (error) => {
    // Check if error is authentication related
    const isAuthError = 
      error?.statusCode === 401 || 
      error?.message?.includes('authentication') ||
      error?.message?.includes('token') ||
      error?.data?.statusCode === 401

    if (isAuthError) {
      // Inject method from the dashboard layout will be called
      // This will redirect to login if available
      const handleAuthError = nuxtApp.$nuxt.payload.handleAuthError
      if (typeof handleAuthError === 'function') {
        handleAuthError(error)
      } else {
        // Fallback to direct reload/redirect
        console.error('Authentication error detected:', error)
        window.location.href = '/provider/4/login'
      }
    }
  })

  // Add a global helper to handle API errors
  return {
    provide: {
      handleApiError: (error: any) => {
        // Check if the error is related to authentication
        const isAuthError = 
          error?.statusCode === 401 || 
          error?.message?.includes('authentication') ||
          error?.message?.includes('token') ||
          error?.data?.statusCode === 401 ||
          error?.data?.statusMessage?.toLowerCase()?.includes('authentication') ||
          error?.data?.statusMessage?.toLowerCase()?.includes('token')
          
        if (isAuthError) {
          // Try to access the provided function from dashboard layout
          const showAuthErrorModal = nuxtApp.$nuxt.payload.showAuthErrorModal
          if (typeof showAuthErrorModal === 'function') {
            showAuthErrorModal()
          } else {
            // Fallback to direct reload
            console.error('Authentication error detected, redirecting to login:', error)
            window.location.href = '/provider/4/login'
          }
          return true
        }
        return false
      }
    }
  }
})
